import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';
import { FaCirclePlus } from "react-icons/fa6";
import logo from "../../../assets/img/avatars/avatar_1.png";
import { loadNFTsForaCollection } from '../../../assets/Data/NFT';
import { Tooltip } from 'react-tooltip';

const AirDrop = () => {
    useDocumentTitle(' Mint');
    const [collection, setCollection] = useState([]);
    const walletAddress = localStorage.getItem("WalletAddress");

    useEffect(() => {
        GetCollection();
    }, [walletAddress])

    const GetCollection = async () => {
        await getCollectionListbyWalletAddress(walletAddress).then(async (data) => {
            if (data.status === 201) {
                const Collect = data.data
                const newArray = await Promise.all(Collect.map(async (item, i) => {
                    const updatedNFTs = await loadNFTsForaCollection(item.contractAddress);
                    if (updatedNFTs.length !== 0) {
                        const UpdateNFTData = updatedNFTs.map((value) => {
                            if (value.owner === item.ownerAddress) {
                                return value
                            }
                            else {
                                return null
                            }
                        })
                        const AvailableNFTArr = UpdateNFTData.filter((data => data !== null));
                        return { ...item, isActive: false, AvailableNFTArr: AvailableNFTArr }; // Update object at specific index
                    }
                    else {
                        return { ...item, isActive: false, AvailableNFTArr: [] }; // Update object at specific index
                    }
                }))
                setCollection(newArray.reverse())
            }
        })
    }

    const handleError = (event) => {
        event.target.src = logo;
    };

     const navigate = useNavigate();
    
        const handleBackClick = () => {
            navigate(-1)
        };
    

    return (
            <div className="container" >
                <button
                        onClick={handleBackClick}
                        className="btn btn-white btn-sm my-40 ml-4"
                    >
                        Back
                    </button>
                <div className="box in__upload mt-40 mb-120">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group space-y-10">
                                <div className="space-y-20">
                                    <div className='space-y-10 drop_ui'>
                                        <h2 className="variationInput ">Choose collection</h2>
                                        <div className="row">
                                            {collection.map((val, i) => (
                                                <>
                                                    {val.AvailableNFTArr.length !== 0 ?
                                                        <Link to={`/collectionDetailsDrop/${val.contractAddress}`} className="col-xl-4 col-lg-4 col-md-6 col-sm-6" key={i}>
                                                            <div className="card__item four">
                                                                <div className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                    <div className="avatars space-x-3">
                                                                        <img
                                                                            src={val.logo}
                                                                            alt=""
                                                                            onError={handleError}
                                                                            className="avatar avatar-lg"
                                                                        />
                                                                    </div>
                                                                    <div className='mx-3'>
                                                                        <h6 className="card_title">
                                                                            <div className="color_black">
                                                                                {val.name}
                                                                            </div>
                                                                        </h6>
                                                                        <div className="card_footer d-block space-y-10">
                                                                            <div className="card_footer justify-content-between">
                                                                                <span className="card_title">
                                                                                    {val.symbol}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                        <div>
                                                                            <h5>Available NFT : <span className='text-primary'>{val.AvailableNFTArr.length}</span></h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                        :
                                                        <div data-tooltip-id="my-tooltip" data-tooltip-content="Add NFTs For to do Air Drop"  className="col-xl-4 col-lg-4 col-md-6 col-sm-6" key={i}>
                                                            <div className="card__item four">
                                                                <div className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                                    <div className="avatars space-x-3">
                                                                        <img
                                                                            src={val.logo}
                                                                            alt=""
                                                                            onError={handleError}
                                                                            className="avatar avatar-lg"
                                                                        />
                                                                    </div>
                                                                    <div className='mx-3'>
                                                                        <h6 className="card_title">
                                                                            <div className="color_black" >
                                                                                {val.name}
                                                                            </div>
                                                                        </h6>
                                                                        <div className="card_footer d-block space-y-10">
                                                                            <div className="card_footer justify-content-between">
                                                                                <span className="card_title text-primary">
                                                                                    {val.symbol}
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                        <div>
                                                                            <h5>Available NFT : <span className='text-primary'>{val.AvailableNFTArr.length}</span></h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <Tooltip id="my-tooltip" />
                                                        </div>}
                                                </>
                                            ))}
                                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6">
                                                <div className="card__item four">
                                                    <Link to="/collectionAdd" className="card_body space-y-10 d-flex align-items-center justify-content-start ">
                                                        <div className="avatars space-x-3">
                                                            <Link to="/collectionAdd">
                                                                <FaCirclePlus color='black' size="65" />
                                                            </Link>
                                                        </div>
                                                        <div className='mx-3'>
                                                            <h6 className="card_title">
                                                                <Link className="color_black" to="/collectionAdd">
                                                                    Create
                                                                </Link>
                                                            </h6>
                                                            <div className="card_footer d-block space-y-10">
                                                                <div className="card_footer justify-content-between">
                                                                    <span className="card_title">
                                                                        ERC-721
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default AirDrop;
